// 对Date的扩展，将 Date 转化为指定格式的String
// 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
// 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
/* eslint-disable */
export default  () => {
  Date.prototype.format = function (fmt) { //author: meizz
    var o = {
      "M+": this.getMonth() + 1,                 //月份
      "d+": this.getDate(),                    //日
      "h+": this.getHours(),                   //小时
      "m+": this.getMinutes(),                 //分
      "s+": this.getSeconds(),                 //秒
      "q+": Math.floor((this.getMonth() + 3) / 3), //季度
      "S": this.getMilliseconds()             //毫秒
    };
    if (/(y+)/.test(fmt))
      fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
      if (new RegExp("(" + k + ")").test(fmt))
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
  };

  Date.prototype.minusDays = function(days) {
    return new Date(this.getTime() - days*60*60*24*1000);
  };

  Date.prototype.getMonday = function () {
    var date = this;
    if(date.getDay()==0)
      return date.minusDays(6);
    else
      return date.minusDays(date.getDay()-1);
  };

  Date.prototype.getDaysNum = function () {
    var date = this;
    var nextDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    return nextDate.getDate();
  }

  Date.prototype.getFirstDayInMonth = function () {
    let month = this.getMonth() + 1;
    if (month < 10) {
      month = `0${month}`;
    }
    return `${this.getFullYear()}-${month}-01`
  }

  Date.prototype.getLastDayInMonth = function () {
    let month = this.getMonth() + 1;
    if (month < 10) {
      month = `0${month}`;
    }
    let day = this.getDaysNum();
    if (day < 10) {
      day = `0${day}`;
    }
    return `${this.getFullYear()}-${month}-${day}`;
  }
  Date.prototype.getnowMonth = function () {
    let month = this.getMonth() + 1;
    if (month < 10) {
      month = `0${month}`;
    }
    return `${this.getFullYear()}-${month}`;
  }
}



// WEBPACK FOOTER //
// ./src/utils/scripts.js